import { useMemo } from 'react';
import { ConversationMessage } from '../interfaces/Derivation';
import {
  ChatMessage,
  mapConversationToMessages,
  parseChatHistoryToMessages,
} from '../adapters/chat.adapter';

export type { ChatMessage };

export const useFullChatMessages = (
  chatData?: string,
  conversation?: ConversationMessage[]
) => {
  return useMemo((): ChatMessage[] => {
    if (
      conversation &&
      Array.isArray(conversation) &&
      conversation.length > 0
    ) {
      return mapConversationToMessages(conversation);
    }

    return parseChatHistoryToMessages(chatData);
  }, [chatData, conversation]);
};
